import { FunctionComponent, ReactNode } from 'react';
import css from './FilterPanel.module.less';

const FilterPanel: FunctionComponent<{ actions: ReactNode }> = ({ children, actions }) => (
  <>
    <div>{children}</div>
    <div className={css.actions}>{actions}</div>
  </>
);

export default FilterPanel;
